import {
  SET_USER_DATA,
  SET_SOURCE_INFO,
  LOAD_REPO,
  LOAD_REPO_ERROR,
  GET_MODULE_CODE,
  GET_MODULE_CODE_ERROR,
  GET_MODULE_CODE_SUCCESS,
  SET_CURRENT_DROPDOWN_STATUS,
  FETCH_INITIAL_DATA,
  FETCH_INITIAL_DATA_SUCCESS,
  CHANGE_CURRENT_DROPDOWN_STATUS,
  RESET_IS_CHANGE_DROPDOWN,
  SET_DIALOG_OPEN,
  SEND_EMAIL_TO_SYSTEM_ADMIN,
  CHANGE_LANGUAGE,
  SET_DIALOG_STATUS,
  FETCH_DATA_CAR_COMPANIES,
  FETCH_DATA_CAR_COMPANIES_SUCCESS,
  FETCH_TARGET_LABELS_SUCCESS,
  AUTO_LABELS_REQUEST,
  AUTO_LABELS_SUCCESS,
  AUTO_LABELS_FAILURE,
  SET_REPORTER_TAB,
  GET_AUDIT_LOGS,
  GET_AUDIT_LOGS_SUCCESS,
  GET_AUDIT_LOGS_ERROR,
} from "./constants";

export function setUserData(payload) {
  return {
    type: SET_USER_DATA,
    payload,
  };
}

export function loadRepo(payload) {
  return {
    type: LOAD_REPO,
    payload,
  };
}

export function loadRepoError(payload) {
  return {
    type: LOAD_REPO_ERROR,
    payload,
  };
}

export function setSourceInfo(payload) {
  return {
    type: SET_SOURCE_INFO,
    payload,
  };
}

export function getModuleCode(payload) {
  return {
    type: GET_MODULE_CODE,
    payload,
  };
}

export function getModuleCodeSuccess(payload) {
  return {
    type: GET_MODULE_CODE_SUCCESS,
    payload,
  };
}

export function getModuleCodeError(payload) {
  return {
    type: GET_MODULE_CODE_ERROR,
    payload,
  };
}

export function setCurrentDropdownStatus(payload) {
  return {
    type: SET_CURRENT_DROPDOWN_STATUS,
    payload,
  };
}

export function changeCurrentDropdownStatus(payload) {
  return {
    type: CHANGE_CURRENT_DROPDOWN_STATUS,
    payload,
  };
}

export function resetIsChangeCurrentDropdown() {
  return {
    type: RESET_IS_CHANGE_DROPDOWN,
  };
}

export function fetchInitialData(payload) {
  return {
    type: FETCH_INITIAL_DATA,
    payload,
  };
}

export function fetchInitialDataSuccess(payload) {
  return {
    type: FETCH_INITIAL_DATA_SUCCESS,
    payload,
  };
}

export const setDialogOpen = (payload) => ({
  type: SET_DIALOG_OPEN,
  payload,
});

export const sendEmailToSystemAdmin = (payload, callback) => ({
  type: SEND_EMAIL_TO_SYSTEM_ADMIN,
  payload,
  callback,
});

export const changeLanguage = (payload) => {
  localStorage.setItem("currentLanguage", payload);
  return {
    type: CHANGE_LANGUAGE,
    payload,
  };
};

export const setDialogStatus = (payload) => {
  return { type: SET_DIALOG_STATUS, payload };
};

export const fetchDataCarCompanies = () => {
  return { type: FETCH_DATA_CAR_COMPANIES };
};

export const fetchDataCarCompaniesSuccess = (payload) => {
  return { type: FETCH_DATA_CAR_COMPANIES_SUCCESS, payload };
};

export const fetchTargetLabelsSuccess = (payload) => {
  return { type: FETCH_TARGET_LABELS_SUCCESS, payload };
};

export const autoLabelRequest = (payload) => {
  return { type: AUTO_LABELS_REQUEST, payload };
};

export const autoLabelSuccess = () => {
  return { type: AUTO_LABELS_SUCCESS };
};

export const autoLabelFailure = () => {
  return { type: AUTO_LABELS_FAILURE };
};
export const setReporterTab = (payload) => ({
  type: SET_REPORTER_TAB,
  payload,
});

export const getAuditLogs = (payload) => ({
  type: GET_AUDIT_LOGS,
  payload,
});

export const getAuditLogsSuccess = (payload) => ({
  type: GET_AUDIT_LOGS_SUCCESS,
  payload,
});

export const getAuditLogsError = (payload) => ({
  type: GET_AUDIT_LOGS_ERROR,
  payload,
});
